module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Day-rain-a0a0b31fec39aecaea6795f2308044fa.svg";